'use strict';

var _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
},
    _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _templateObject = _taggedTemplateLiteral(['\n  /* Remove the margin in Firefox and Safari. */\n  margin: 0;\n\n  /* Show the overflow in IE. */\n  overflow: visible;\n\n  /* Remove the inheritance of text transform in Edge, Firefox, and IE. */\n  text-transform: none;\n\n  /* Remove the inner border and padding in Firefox. */\n  &::-moz-focus-inner {\n    border-style: none;\n    padding: 0;\n  }\n\n  /* Restore the focus styles unset by the previous rule. */\n  &:-moz-focusring {\n    outline: 1px dotted;\n  }\n\n  /* Change the cursor in all browsers. */\n  cursor: pointer;\n\n  /* Restore the default cursor to disabled elements unset by the previous rule. */\n  &:disabled {\n    cursor: default;\n  }\n\n  /* Remove gaps in links underline in iOS 8+ and Safari 8+. */\n  text-decoration-skip: objects;\n  text-decoration-skip-ink: none;\n'], ['\n  /* Remove the margin in Firefox and Safari. */\n  margin: 0;\n\n  /* Show the overflow in IE. */\n  overflow: visible;\n\n  /* Remove the inheritance of text transform in Edge, Firefox, and IE. */\n  text-transform: none;\n\n  /* Remove the inner border and padding in Firefox. */\n  &::-moz-focus-inner {\n    border-style: none;\n    padding: 0;\n  }\n\n  /* Restore the focus styles unset by the previous rule. */\n  &:-moz-focusring {\n    outline: 1px dotted;\n  }\n\n  /* Change the cursor in all browsers. */\n  cursor: pointer;\n\n  /* Restore the default cursor to disabled elements unset by the previous rule. */\n  &:disabled {\n    cursor: default;\n  }\n\n  /* Remove gaps in links underline in iOS 8+ and Safari 8+. */\n  text-decoration-skip: objects;\n  text-decoration-skip-ink: none;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      /* top/bottom padding needs to be 0 so <button> and <a> render the same\n      (<button> has some padding by default) */\n      padding: 0 ', ';\n    '], ['\n      /* top/bottom padding needs to be 0 so <button> and <a> render the same\n      (<button> has some padding by default) */\n      padding: 0 ', ';\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      max-width: ', ';\n      height: ', ';\n    '], ['\n      max-width: ', ';\n      height: ', ';\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      margin-', ': ', ';\n    '], ['\n      margin-', ': ', ';\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n          fill: ', '; /* cloud 5 */\n        '], ['\n          fill: ', '; /* cloud 5 */\n        ']),
    _templateObject6 = _taggedTemplateLiteral(['\n        display: inline;\n      '], ['\n        display: inline;\n      ']),
    _templateObject7 = _taggedTemplateLiteral(['\n      display: inline-block;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    '], ['\n      display: inline-block;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    ']),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents),
    _themes = require('../themes'),
    _styles = require('../styles'),
    _propTypes3 = require('../propTypes'),
    _Tooltip = require('../Tooltip'),
    _Tooltip2 = _interopRequireDefault(_Tooltip),
    _componentTheme = require('./componentTheme'),
    _componentTheme2 = _interopRequireDefault(_componentTheme),
    _utils = require('../utils');

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var getVariant = function getVariant(color, naked, secondary) {
  if ('neutral' === color) return naked ? 'neutralNaked' : 'neutral';
  return 'white' === color ? naked ? 'whiteNaked' : 'white' : secondary ? naked ? 'themeSecondaryNaked' : 'themeSecondary' : naked ? 'themePrimaryNaked' : 'themePrimary';
},
    getVariantStyle = function getVariantStyle(property, state) {
  return function (props) {
    var _props$sc = props.sc,
        color = _props$sc.color,
        naked = _props$sc.naked,
        secondary = _props$sc.secondary,
        variant = getVariant(color, naked, secondary),
        token = 'Button_' + property + '_' + variant + (state ? '_' + state : '');
    return (0, _themes.getStyle)(token);
  };
},
    getHeight = function getHeight() {
  return function (props) {
    var _props$sc2 = props.sc,
        inline = _props$sc2.inline,
        size = _props$sc2.size;
    if (inline) return 'auto';
    var _props$theme$vstui = props.theme.vstui,
        rem = _props$theme$vstui.rem,
        typography = _props$theme$vstui.typography,
        minHeight = (0, _themes.getStyle)('Button_minHeight_' + size)(props),
        height = Math.max(minHeight, 1.5 * typography.fontSize);
    return rem(height);
  };
},
    normalizeStyles = (0, _styles.css)(_templateObject),
    Styled = {
  div: {},
  span: {}
};

Styled.Tooltip = (0, _styledComponents2.default)(_Tooltip2.default).withConfig({
  displayName: 'Button__Tooltip'
})(['display:inline-block;width:', ';'], function (_ref) {
  var sc = _ref.sc;
  return sc.fullWidth && '100%';
}), Styled.button = _styledComponents2.default.button.withConfig({
  displayName: 'Button__button'
})(['', ';', ';display:', ';box-sizing:border-box;align-items:center;width:', ';max-width:100%;height:', ';min-height:', ';', ';background-color:', ';border-width:', ';border-style:', ';border-color:', ';border-radius:', ';color:', ';font-family:', ';font-size:', ';font-weight:', ';text-decoration:', ';-webkit-font-smoothing:antialiased;transition-property:none;transition-duration:', ';transition-timing-function:', ';&:-moz-focusring{outline-color:', ';}&:focus{background-color:', ';border-color:', ';outline:none;box-shadow:', ';color:', ';}&:hover{background-color:', ';border-color:', ';color:', ';&:focus{border-color:', ';}}&:active{background-color:', ';border-color:', ';color:', ';}&:disabled{background-color:', ';border-color:', ';color:', ';font-weight:', ';text-decoration:none;}'], function (props) {
  return props.inheritStyles ? '' : _styles.resetInheritedStyles;
}, normalizeStyles, function (_ref2) {
  var sc = _ref2.sc;
  return sc.inline ? 'inline' : 'inline-flex';
}, function (_ref3) {
  var sc = _ref3.sc;
  return sc.fullWidth && '100%';
}, getHeight(), getHeight(), function (_ref4) {
  var sc = _ref4.sc,
      fullWidth = sc.fullWidth,
      iconEnd = sc.iconEnd,
      iconStart = sc.iconStart,
      inline = sc.inline,
      size = sc.size;
  if (inline) return 0;
  var paddingHorizontal,
      sizeCapitalized = size.replace(/^\w/, function (letter) {
    return letter.toUpperCase();
  });
  return paddingHorizontal = fullWidth ? (0, _themes.getStyle)('Button_paddingHorizontal_fullWidth') : iconStart || iconEnd ? (0, _themes.getStyle)('Button_paddingHorizontal_withIcon' + sizeCapitalized) : (0, _themes.getStyle)('Button_paddingHorizontal_' + size), (0, _styles.css)(_templateObject2, paddingHorizontal);
}, getVariantStyle('backgroundColor'), (0, _themes.getStyle)('Button_borderWidth'), (0, _themes.getStyle)('Button_borderStyle'), getVariantStyle('borderColor'), (0, _themes.getStyle)('Button_borderRadius'), getVariantStyle('color'), (0, _themes.getStyle)('Button_fontFamily'), function (props) {
  return props.sc.inline ? props.theme.vstui.rem((0, _themes.getStyle)('Button_fontSize_inline')(props)) : props.theme.vstui.rem((0, _themes.getStyle)('Button_fontSize_' + props.sc.size)(props));
}, function (_ref5) {
  var sc = _ref5.sc,
      theme = _ref5.theme,
      color = sc.color,
      naked = sc.naked,
      secondary = sc.secondary;
  return naked ? theme.vstui.Button_fontWeight_naked : 'neutral' === color ? theme.vstui.Button_fontWeight_neutral : 'white' === color ? theme.vstui.Button_fontWeight_white : secondary ? theme.vstui.Button_fontWeight_themeSecondary : theme.vstui.Button_fontWeight_themePrimary;
}, function (props) {
  return props.sc.inline ? (0, _themes.getStyle)('Button_textDecoration_inline') : (0, _themes.getStyle)('Button_textDecoration');
}, (0, _themes.getStyle)('Button_transitionDuration'), function (_ref6) {
  var theme = _ref6.theme;
  return theme.vstui.Button_transitionEasing;
}, function (_ref7) {
  var sc = _ref7.sc,
      theme = _ref7.theme,
      color = sc.color,
      secondary = sc.secondary;
  return 'neutral' === color ? null : 'white' === color ? theme.vstui.Button_backgroundColor_white : secondary ? theme.vstui.Button_backgroundColor_themeSecondary_hover : theme.vstui.Button_backgroundColor_themePrimary_hover;
}, getVariantStyle('backgroundColor', 'focus'), getVariantStyle('borderColor', 'focus'), getVariantStyle('boxShadow', 'focus'), getVariantStyle('color', 'focus'), getVariantStyle('backgroundColor', 'hover'), getVariantStyle('borderColor', 'hover'), getVariantStyle('color', 'hover'), getVariantStyle('borderColor', 'focus'), getVariantStyle('backgroundColor', 'active'), getVariantStyle('borderColor', 'active'), getVariantStyle('color', 'active'), getVariantStyle('backgroundColor', 'disabled'), getVariantStyle('borderColor', 'disabled'), getVariantStyle('color', 'disabled'), (0, _themes.getStyle)('Button_fontWeight_disabled')), Styled.button.displayName = 'Styled_button', Styled.a = Styled.button.withComponent('a'), Styled.a.displayName = 'Styled_a', Styled.div.buttonContent = _styledComponents2.default.div.withConfig({
  displayName: 'Button__buttonContent'
})(['display:', ';align-items:center;justify-content:', ';min-width:100%;'], function (_ref8) {
  var sc = _ref8.sc;
  return sc.inline ? 'inline' : 'flex';
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.vstui.ButtonContent_justifyContent;
}), Styled.div.iconWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'Button__iconWrapper'
})(['display:flex;align-self:center;flex-shrink:0;', ';', ';svg{max-width:100%;max-height:100%;}', ':disabled & > svg{', ';}'], function (_ref10) {
  var sc = _ref10.sc,
      theme = _ref10.theme,
      size = sc.size,
      height = theme.vstui['size_' + size],
      iconSize = 'auto';
  return 28 > height ? iconSize = '14px' : 32 > height && (iconSize = '16px'), (0, _styles.css)(_templateObject3, iconSize, iconSize);
}, function (_ref11) {
  var sc = _ref11.sc,
      hasContent = sc.hasContent,
      iconPosition = sc.iconPosition,
      naked = sc.naked,
      margin = '0';
  hasContent && (naked && (margin = '6px'), margin = '10px');
  var side = 'start' === iconPosition ? 'right' : 'left';
  return (0, _styles.css)(_templateObject4, side, margin);
}, Styled.button, function (_ref12) {
  var sc = _ref12.sc,
      color = sc.color;
  return 'theme' === color || 'neutral' === color ? (0, _styles.css)(_templateObject5, (0, _themes.getStyle)('ButtonIcon_fill_disabled')) : null;
}), Styled.div.labelText = _styledComponents2.default.div.withConfig({
  displayName: 'Button__labelText'
})(['', ';'], function (_ref13) {
  var sc = _ref13.sc,
      inline = sc.inline;
  return inline ? (0, _styles.css)(_templateObject6) : (0, _styles.css)(_templateObject7);
}), Styled.div.labelText.displayName = 'Styled_div_label', Styled.span.hidden = _styledComponents2.default.span.withConfig({
  displayName: 'Button__hidden'
})(['', ';'], (0, _styles.visuallyHidden)());

var Button = function (_Component) {
  function Button() {
    _classCallCheck(this, Button);

    var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this));

    return _this.tooltipId = (0, _utils.generateUniqueId)('tooltip'), _this;
  }

  return _inherits(Button, _Component), _createClass(Button, [{
    key: 'renderButton',
    value: function renderButton(_ref14) {
      var theme = _ref14.theme,
          tooltipId = _ref14.tooltipId,
          _props = this.props,
          children = _props.children,
          className = _props.className,
          color = _props.color,
          colorBehindButton = _props.colorBehindButton,
          description = _props.description,
          disabled = _props.disabled,
          fullWidth = _props.fullWidth,
          href = _props.href,
          iconEndProp = _props.iconEnd,
          iconStartProp = _props.iconStart,
          inline = _props.inline,
          inheritStyles = _props.inheritStyles,
          label = _props.label,
          nakedProp = _props.naked,
          secondary = _props.secondary,
          size = _props.size,
          target = _props.target,
          themeIgnored = _props.theme,
          tooltipPlacementIgnored = _props.tooltipPlacement,
          otherProps = _objectWithoutProperties(_props, ['children', 'className', 'color', 'colorBehindButton', 'description', 'disabled', 'fullWidth', 'href', 'iconEnd', 'iconStart', 'inline', 'inheritStyles', 'label', 'naked', 'secondary', 'size', 'target', 'theme', 'tooltipPlacement']),
          iconEnd = iconEndProp && _react2.default.cloneElement(iconEndProp, {
        className: iconEndProp.props.className
      }),
          iconStart = iconStartProp && _react2.default.cloneElement(iconStartProp, {
        className: iconStartProp.props.className
      }),
          hasContent = void 0 !== children && '' !== children,
          ButtonComponent = href && !disabled ? Styled.a : Styled.button,
          conditionalProps = {};

      description && (conditionalProps['aria-describedby'] = tooltipId), target && (conditionalProps.rel = 'noopener'), tooltipId || (conditionalProps.className = className);
      var height = theme.vstui['size_' + size];
      return _react2.default.createElement(ButtonComponent, _extends({}, otherProps, conditionalProps, {
        "aria-label": label,
        disabled: disabled,
        href: href,
        sc: {
          color: color,
          colorBehindButton: colorBehindButton,
          fullWidth: fullWidth,
          height: height,
          iconEnd: iconEnd,
          iconStart: iconStart,
          inline: inline,
          inheritStyles: inheritStyles,
          naked: inline || nakedProp,
          secondary: secondary,
          size: size
        },
        target: target,
        theme: theme
      }), _react2.default.createElement(Styled.div.buttonContent, {
        sc: {
          fullWidth: fullWidth,
          inline: inline
        },
        theme: theme
      }, iconStart && _react2.default.createElement(Styled.div.iconWrapper, {
        sc: {
          color: color,
          hasContent: hasContent,
          iconPosition: 'start',
          size: size
        },
        theme: theme
      }, iconStart), _react2.default.createElement(Styled.div.labelText, {
        sc: {
          inline: inline
        }
      }, children, '_blank' === target && _react2.default.createElement(Styled.span.hidden, null, ' (opens in a new window)')), iconEnd && _react2.default.createElement(Styled.div.iconWrapper, {
        sc: {
          color: color,
          height: height,
          hasContent: hasContent,
          iconPosition: 'end'
        },
        theme: theme
      }, iconEnd)));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          description = _props2.description,
          disabled = _props2.disabled,
          fullWidth = _props2.fullWidth,
          inheritStyles = _props2.inheritStyles,
          label = _props2.label,
          themeProp = _props2.theme,
          tooltipPlacement = _props2.tooltipPlacement,
          theme = (0, _componentTheme2.default)(themeProp);
      return !disabled && (description || label) ? _react2.default.createElement(Styled.Tooltip, {
        className: className,
        id: this.tooltipId,
        placement: tooltipPlacement,
        sc: {
          fullWidth: fullWidth,
          inheritStyles: inheritStyles
        },
        theme: theme,
        title: description || label
      }, this.renderButton({
        theme: theme,
        tooltipId: this.tooltipId
      })) : this.renderButton({
        theme: theme
      });
    }
  }]), Button;
}(_react.Component);

Button.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  color: _propTypes2.default.oneOf(['theme', 'neutral', 'white']),
  colorBehindButton: function colorBehindButton(props, propName, componentName) {
    if ('white' === props.color && !props.naked && !props.inline) {
      if (props[propName] === void 0) return new Error('Please add prop `' + propName + '` to `' + componentName + '`');
      if ('string' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`.');
    }
  },
  description: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  fullWidth: _propTypes2.default.bool,
  href: _propTypes2.default.string,
  iconEnd: function iconEnd(props, propName, componentName) {
    var iconEnd = props[propName];
    if (iconEnd && 'Icon' !== iconEnd.type.vstuiName) return new Error('Invalid prop `' + propName + '` of type `' + iconEnd.type.displayName + '` supplied to `' + componentName + '`, expected instance of `Icon`.');
  },
  iconStart: function iconStart(props, propName, componentName) {
    var iconStart = props[propName];
    if (iconStart && 'Icon' !== iconStart.type.vstuiName) return new Error('Invalid prop `' + propName + '` of type `' + iconStart.type.displayName + '` supplied to `' + componentName + '`, expected instance of `Icon`.');
  },
  inheritStyles: _propTypes2.default.bool,
  inline: _propTypes2.default.bool,
  label: function label(props, propName, componentName) {
    if (props.children === void 0 || '' === props.children) {
      if (props[propName] === void 0) return new Error('Please add either prop `' + propName + '` or prop `children` to `' + componentName + '`.');
      if ('string' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`.');
    }
  },
  naked: _propTypes2.default.bool,
  secondary: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  target: _propTypes2.default.string,
  theme: _propTypes3.themeShape,
  tooltipPlacement: _propTypes2.default.oneOf(['auto', 'top', 'right', 'bottom', 'left', 'auto-start', 'top-start', 'right-start', 'bottom-start', 'left-start', 'auto-end', 'top-end', 'right-end', 'bottom-end', 'left-end'])
}, Button.defaultProps = {
  color: 'theme',
  size: 'medium',
  tooltipPlacement: 'top',
  theme: (0, _themes.createTheme)()
}, Button.displayName = 'Button';
var ButtonWithTheme = (0, _themes.withTheme)(Button);
ButtonWithTheme.WrappedComponent = Button, exports.default = ButtonWithTheme;